var _circle, _path, _g, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFuse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#0A2336"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_739_1540)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_739_1540",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 11,
    width: 12,
    height: 6
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00003 11.823H15.9684V16.3921H4.00003V11.823Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_739_1540)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.97258 14.1485C9.55086 14.1485 9.15896 14.0601 8.83908 13.8928L5.3946 12.092L4.36246 12.7122C3.87185 13.0069 3.88042 13.4587 4.38157 13.7208L9.14561 16.2118C9.37699 16.3327 9.67281 16.3922 9.97258 16.3922C10.3226 16.3922 10.6778 16.3112 10.9421 16.1524L15.6059 13.3497C16.0965 13.0548 16.088 12.603 15.5868 12.3411L14.5964 11.823L11.2827 13.8145C10.9241 14.0298 10.4589 14.1485 9.97258 14.1485Z",
    fill: "url(#paint0_linear_739_1540)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6174 9.35896L14.7904 8.92017L12.8646 10.0944L12.534 10.296L12.2035 10.4975L11.302 11.0473C10.9425 11.2667 10.4758 11.3873 9.98839 11.3873C9.56556 11.3873 9.17263 11.2974 8.85191 11.1273L7.81902 10.5793L7.47715 10.3981L7.13528 10.2167L5.2321 9.2068L4.36346 9.73653C3.87156 10.0365 3.87999 10.496 4.38247 10.7626L5.37569 11.2895L5.71756 11.4709L6.05927 11.6522L9.15924 13.2968C9.39107 13.4198 9.68783 13.4802 9.98839 13.4802C10.3392 13.4802 10.6954 13.3979 10.9603 13.2364L13.9406 11.4191L14.2713 11.2176L14.6018 11.0161L15.6366 10.3851C16.1285 10.0852 16.1199 9.62558 15.6174 9.35896Z",
    fill: "url(#paint1_linear_739_1540)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6174 6.67029L10.8407 4.18034C10.6088 4.05935 10.3123 4 10.0115 4C9.66073 4 9.30448 4.08099 9.03961 4.23968L4.36346 7.04146C3.87156 7.33606 3.87999 7.78756 4.38247 8.04954L5.20947 8.48071L5.55134 8.65892L5.89321 8.83712L7.79638 9.8293L8.13826 10.0073L8.48013 10.1857L9.15924 10.5398C9.39107 10.6607 9.68783 10.72 9.98839 10.72C10.3392 10.72 10.6954 10.639 10.9603 10.4803L11.5198 10.1451L11.8504 9.94701L12.1809 9.74897L14.1067 8.59514L14.4373 8.3971L14.7678 8.19906L15.6366 7.67854C16.1285 7.38394 16.1199 6.93227 15.6174 6.67029Z",
    fill: "url(#paint2_linear_739_1540)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_739_1540",
    x1: 9.9842,
    y1: 4.39854,
    x2: 9.9842,
    y2: 16.3922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3F9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6FB8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_739_1540",
    x1: 10,
    y1: 4.40798,
    x2: 10,
    y2: 16.1164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1FFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF16D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_739_1540",
    x1: 10,
    y1: 4,
    x2: 10,
    y2: 16.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3F9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6FB8C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_739_1540"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuse);
export default __webpack_public_path__ + "static/media/fuse.bd344c7c4d2095d6b986811fa8a71f12.svg";
export { ForwardRef as ReactComponent };